// import moment from 'moment'
// import { Modal } from 'antd-mobile'
// import Trial from 'src/lib/bussiness/trial.js'
// import staticData from 'src/lib/bussiness/staticData.js'
import { urlQuery, getAttrObject, sessionStorage, ajax, transDateFormatDDMMYYYY, isArray, showError, template, getAgeRange } from '@src/utils'

let timer = null
// const { paymentFrequencyMap } = staticData
const MediaMap = {
  1: 'ID_FRONT_IMAGE',
  2: 'PASSPORT_IMAGE',
  3: 'SELFIE_IMAGE'
}

const PAGEKEYS = [
  'HOLDER', // 投保人： hkid 护照 自拍（注：区分已实名和未实名）
  'CONTACTMESSAGE', // 联系信息： 电话邮箱学历地址等（注：区分已实名和未实名）
  'BENEFICIARY', // 受益人： 非vhis才有（注：处理其他订单进来的情况）
  'INSURECHOOSE', // 被保人：vhis才有（注：处理其他订单进来的情况）
  'ESTIMATEPREMIUM', // 预估保费：可修改保额、保障期、是否吸烟，可输入优惠码等信息（注：从缓存取试算因子和处理其他订单进来的情况）
  'CONFIRMINFO'// 确认信息：前面所有信息展示+底部声明
]

// 因为个人信息返回的字段和投保因子的字段名不同，需要转换一下
const KEYMAP = {
  certiNo: 'certificateNumber',
  certiType: 'certificateType',
  emails: 'email',
  givenName: 'givenName',
  lastName: 'surname',
  phones: 'phoneNumber',
  phone: 'phoneNumber',
  smoke: 'smoking',
  height: 'insurantHeight',
  occupationCode: 'occupation',
  building: 'residentialFlat',
  street: 'residentialBuilding',
  district: 'residentialDistrict'
}

const sortAndGetValue = ({ data = [], sortArray = [], valueObj = {} }) => {
  let result = []
  data.forEach((item) => {
    let code = item.customizeCode
    // 此处判断 customizeCode 在不在传入的 KEYS 内部并且对应的 valueObj 里面的值不为空
    if (sortArray.indexOf(code) > -1) {
      item.value = valueObj[code]
      if (item.values) {
        item.key = valueObj[code]
      }
      if (item.values && getAttrObject(item.values, 'customizeValue', valueObj[code])[0]) {
        item.value = getAttrObject(item.values, 'customizeValue', valueObj[code])[0].customizeText
        item.key = getAttrObject(item.values, 'customizeValue', valueObj[code])[0].customizeValue
      }
      if (code === 'birthday' || code === 'passportExpiryDate') {
        item.value = transDateFormatDDMMYYYY(item.value)
      }
      result.push(item)
    }
  })
  result = result.sort((a, b) => {
    return sortArray.indexOf(a.customizeCode) - sortArray.indexOf(b.customizeCode) > 0 ? 1 : -1
  })
  return result
}

// 判断护照OCR信息是否与hkid的OCR信息一致
const judgeOcrInfo = (HKIDInfo, passportInfo = {}) => {
  let { birthday = '', surname = '', gender = '' } = HKIDInfo // givenName = '', 先去掉givenName的判断
  let birthday1 = passportInfo.birthday || ''
  let surName1 = passportInfo.surname || ''
  let gender1 = passportInfo.gender || ''
  birthday = birthday.replace(/\d{2}(\d{2})-(\d{2})-(\d{2}).*/, '$1$2$3')
  if (birthday.toLowerCase() !== birthday1.toLowerCase() ||
    // givenName.toLowerCase() !== givenName1.toLowerCase() ||
    surname.toLowerCase() !== surName1.toLowerCase() ||
    gender.toLowerCase() !== gender1.toLowerCase()) {
    return false
  }
  return true
}

// 检测国籍是否在列表内
const checkNationality = (nationlity, nationlityList = []) => {
  const obj = getAttrObject(nationlityList, 'customizeValue', nationlity)[0]
  if (obj && obj.customizeValue) {
    return true
  }
  return false
}

const getDefaultModule = (arr = [], key = '', type = '') => { // 获取default的对象
  if (arr.length && key) {
    const obj = arr.find((item) => {
      if (type) {
        return item['addressType'] === type
      } else {
        return item[key] === 'DEFAULT'
      }
    })
    if (obj) {
      return obj
    } else {
      return arr[0]
    }
  } else {
    return {}
  }
}

const resetInitData = (userData) => { // 兼容处理--因为字段不一致
  // 这地方，应该要和投保因子接口结合起来，如果该投保因子，没有配置这个属性，不应该把值赋过来
  if (!userData) {
    return userData
  }
  for (let key in userData) {
    if (userData[key]) { // 如果有值
      let insureKey = KEYMAP[key] || key // 这个是相当于 email || emails
      if (KEYMAP[key]) { // 如果说是certificateNumber等这5项
        userData[insureKey] = userData[key]
        if (typeof userData[insureKey] === 'object') {
          userData[insureKey] = userData[insureKey][insureKey]
        }
      }
      // 因为手机号，邮箱，地址竟然都是用不同的字段来判断是否是
      if (isArray(userData[key])) {
        // *TODO: 需要做两件事情， 1.取出Default的那个对象，设置value 2. 取出手机号的default的对象，设置联系方式类型的value
        let obj = {}
        if (insureKey === 'email') {
          obj = getDefaultModule(userData[key], 'emailType')
          userData[insureKey] = obj.emailDetail || obj.email || ''
        }
        if (insureKey === 'phoneNumber') {
          obj = getDefaultModule(userData[key], 'phoneCategory')
          userData[insureKey] = obj.phoneNo || ''
          userData['contactNo'] = obj.phoneNo || ''
        }
        
        if (key === 'addresses') { // 需要对地址进行下处理
          obj = getDefaultModule(userData[key], 'addressCategory', 'RESIDENTIAL_ADDRESS')
          let obj1 = getDefaultModule(userData[key], 'addressCategory', 'CORRESPONDENCE_ADDRESS')
          if (obj) {
            userData.residentialFlat = obj.building || ''
            userData.residentialBuilding = obj.street || ''
            userData.residentialDistrict = obj.district || ''
          }
          if (obj1) {
            userData.correspondenceFlat = obj1.building || ''
            userData.correspondenceBuilding = obj1.street || ''
            userData.correspondenceDistrict = obj1.district || ''
          }
        }
        
        if (key === 'certiInfo') { // 需要对证件信息
          let faceObj1 = getAttrObject(userData[key], 'certiType', 'PERMHKID')[0]
          let faceObj2 = getAttrObject(userData[key], 'certiType', 'NONPERMHKID')[0]
          let backObj = getAttrObject(userData[key], 'certiType', 'HUZHAO')[0]
          let selfObj = getAttrObject(userData[key], 'certiType', 'SELFIE')[0]
          
          let obj = faceObj1 || faceObj2
          if (obj) {
            userData.certificateNumber = obj.certiNo || userData.certificateNumber
            userData.certificateType = obj.certiType || userData.certificateType
            userData.certiFaceUrl = obj.certiFaceUrl || userData.certiFaceUrl
            userData.certiVersion = obj.certiVersion || userData.certiVersion
          }
          if (backObj) {
            console.log('backObj', backObj)
            userData.passportPhotoUrl = backObj.certiFaceUrl || userData.passportPhotoUrl
            userData.passportNo = backObj.certiNo || userData.passportNo
            userData.passportExpiryDate = backObj.passportExpiryDate || backObj.passportExpiredDate || backObj.expiryDate || userData.passportExpiryDate
          }
          if (selfObj) {
            userData.selfie = selfObj.certiFaceUrl || userData.selfie
          }
        }
      }
    }
  }
  return userData
}

export default {
  name: 'onlineApplicationModel',
  initialState: {
    currentKey: PAGEKEYS[0],
    insureHkidVersionMap: {},
    holderHkidVersion: '',
    insureNextDisable: false,
    infoFromDetail: false,
    errorVisible: false,
    errorText: '',
    nextDisableMap: {},
    minorDisableBtn: true,
    minorData: {},
    userData: {
      isVerifyCerti: false,
      idCardUpload: false, // 是否上传 id card 成功
      idCardUploadErrTxt: '', // 上传 投保人 id card 错误提示信息，
      insureIdCardUploadErrTxt: '', // 上传 被保人 id card 错误提示信息
      passportUpload: false, // 是否上传护照成功
      passportUploadErrTxt: '', // 上传护照错误提示信息
      selfUpload: false, // 是否上传 大头照成功
      selfUploadErrTxt: '', // 上传大头照错误提示信息
      verified: 'NO', // 用户是否实名
      payFrequencyType: '', // 缴费频率
      ageMatch: true, // 投保人年龄是否符合范围
      ocrDisabled: false
    },
    oldSelfie: '',
    insureOcrInfo: {}, // 被保人ocrinfo
    birthCertiImg: '', // 被保人出生证明
    // 创建订单的请求数据结构
    submitOrderData: {
      'orderType': 'COMMON',
      'channel': 'DM_PC',
      'isReiveCampaignInformation': 'NO'
    },
    premium: {},
    pageKeys: [],
    factorList: [],
    saRange: [],
    blocksMap: {},
    initValueObj: {},
    initInfo: {},
    nationInList: true,
    idObj: {},
    insureErrorModalVisible: false,
    insureOcrObjData: {},
    ocrUploadStatus: {
      ocrIdCardUpload: false,
      ocrPassportUpload: false
    },
    dmMark: 'NO', // 是否增加dm
    otpValidateVisible: false,
    otpPassedList: []
  },
  reducers: {
    setOldSelfie (state, data) {
      return { ...state, oldSelfie: data}
    },
    setCurrentKey (state, data) {
      return { ...state, currentKey: data}
    },
    setUserData (state, data) {
      console.log('testuserdata:', data)
      return { ...state, userData: { ...state.userData, ...data}}
    },
    setHolderHkidVersion (state, data) {
      return { ...state, holderHkidVersion: data}
    },
    setInsureHkidVersionMap (state, data) {
      return { ...state, insureHkidVersionMap: data}
    },
    setSubmitOrderData (state, data) {
      // if (data.holder && Object.keys(data.holder).length !== 0) {
      //   let cuid = urlQuery('cuid')
      //   sessionStorage.set(`session-holder-${cuid}`, JSON.stringify(data.holder))
      // }
      console.log('setSubmitOrderData:', data, { ...state.submitOrderData, ...data}, { ...state, submitOrderData: { ...state.submitOrderData, ...data}})
      return { ...state, submitOrderData: { ...state.submitOrderData, ...data}}
    },
    setTempHolderInfo (state, data) {
      return { ...state, tempHolderInfo: { ...state.tempHolderInfo, ...data}}
    },
    setTempHolderErrorInfo (state, data) {
      return { ...state, tempHolderErrorInfo: { ...state.tempHolderErrorInfo, ...data}}
    },
    setNextDisableMap (state, data) {
      return { ...state, nextDisableMap: { ...state.nextDisableMap, ...data}}
    },
    setMinorDisableBtn (state, data) {
      return { ...state, minorDisableBtn: data}
    },
    setMinorData (state, data) {
      return { ...state, minorData: { ...state.minorData, ...data}}
    },
    setInsureNextDisable (state, data) {
      return { ...state, insureNextDisable: data}
    },
    setInsureErrorModalVisible (state, data) {
      return { ...state, insureErrorModalVisible: data}
    },
    setInfoFromDetail (state, data) {
      return { ...state, infoFromDetail: data}
    },
    setAddressData (state, data) {
      return { ...state, submitOrderData: { ...state.submitOrderData, ...data}}
    },
    setInsureOcrInfo (state, data) {
      return { ...state, insureOcrInfo: data}
    },
    setBirthCertiImg (state, data) {
      return { ...state, birthCertiImg: data}
    },
    setPageKeys (state, data) {
      return { ...state, pageKeys: data}
    },
    setPremium (state, data) {
      return { ...state, premium: data}
    },
    setInit (state, data) {
      return { ...state, ...data}
    },
    setInitInfo (state, data) {
      return { ...state, initValueObj: data.initValueObj, initInfo: data.initInfo}
    },
    setBlockInfo (state, data) {
      return { ...state, blocksMap: data}
    },
    setNationInList (state, data) {
      return { ...state, nationInList: data}
    },
    setIdObjData (state, data) {
      return { ...state, idObj: { ...state.idObj, ...data}}
    },
    setInsureObjData (state, data) {
      return { ...state, insureOcrObjData: { ...state.insureOcrObjData, ...data}}
    },
    setOcrUploadStatus (state, data) {
      return { ...state, ocrUploadStatus: { ...state.ocrUploadStatus, ...data}}
    },
    setdmMark (state, data) {
      return { ...state, dmMark: data}
    },
    setOtpValidateVisible (state, data) {
      return { ...state, otpValidateVisible: data}
    },
    setOtpPassedList (state, data) {
      return { ...state, otpPassedList: [...state.otpPassedList, ...data]}
    }
  },
  effects: {
    // getInitInsureData (opt = { data: {}, callback: null }) {
    //   let cuid = urlQuery('cuid') || 'Adsfyh4540887f'
    //   let sessionKey = 'insure_' + cuid
    //   let storageInfo = sessionStorage.get(sessionKey)
    //   storageInfo = storageInfo ? JSON.parse(storageInfo) : {}
    //
    //   if (opt.data) {
    //     storageInfo = opt.data
    //   }
    //
    //   let holder = storageInfo.holder || storageInfo.holderCusts
    //   let insurants = storageInfo.insurants || storageInfo.insureCusts
    //   let initValueObj = {
    //     1: holder ? [holder] : null,
    //     2: insurants || null
    //   }
    //   let initInfo = storageInfo
    //
    //   actions.onlineApplicationModel.setInitInfo({ initValueObj, initInfo })
    //   if (typeof opt.callback === 'function') {
    //     opt.callback(initInfo)
    //   }
    // },
    // async requestInsureFactors (opt = { data: {}, callback: null }) { // 可以直接传callback  也可以传对象
    //   let data = opt.data || {}
    //   let goodsId = urlQuery('goodsId') || data.goodsId
    //   let goodPlanId = urlQuery('goodsPlanId') || data.goodsPlanId
    //   let packageId = urlQuery('packageId') || data.packageId || ''
    //   console.log('requestInsureFactors')
    //   if (!goodsId || !goodPlanId) {
    //     return
    //   }
    //   await ajax({
    //     url: '/order/level/factors',
    //     loading: true,
    //     data: {
    //       goodsId,
    //       goodPlanId,
    //       packageId
    //     }
    //   }).then((result) => {
    //     if (result.success) {
    //       let goodsTopicInsureFactorsResDTOS = (result && result.value && result.value.goodsTopicInsureFactorsResDTOS) || []
    //       let factors = {}
    //       goodsTopicInsureFactorsResDTOS.forEach((item) => {
    //         factors[item.topic] = item.factors || []
    //       })
    //       // let relations = getAttrObject(factors['INSURED'], 'customizeCode', 'relationWithHolders')[0]
    //       // relations && relations.show && (relations.show.defaultValue = 'SELF')
    //       // console.log('relations', factors)
    //       actions.onlineApplicationModel.setBlockInfo({
    //         1: factors['POLICYHOLDER'],
    //         2: factors['INSURED'],
    //         3: factors['BENEFICIARY']
    //       })
    //       let callback = opt.callback
    //       if (typeof callback === 'function') {
    //         callback && callback()
    //       }
    //     }
    //   })
    // },
    // async requestFileCode () {
    //   let res = await ajax({
    //     url: '/GETFILECODE',
    //     loading: true,
    //     data: {
    //       module: 'ORDER'
    //     }
    //   })
    //   return res
    // },
    // // 已登陆用户获取用户详情
    // async requestUserData (data, getState) {
    //   console.log('requestUserData', data)
    //   let { userInfo } = getState().mainModel
    //   let { idObj } = getState().onlineApplicationModel
    //   // let { cuid } = data
    //   // 通过 cuid 获取被保人信息获取 session 中的投保人信息，holder
    //   // 已登陆：请求用户数据，如果用户存在被保人信息，就取这部分的数据，没有的话获取上上一步的 holder，如果 holder 也为空的话显示为空
    //   // 未登录：先根据 cuid 从 session 中去获取 orderNo 如果有就去获取订单详情，没有的话获取上一步获取到的 holder, 如果 holder 页无的话显示为空
    //   // let sessionHolder = JSON.parse(sessionStorage.get(`session-holder-${cuid}`))
    //   let sessionOrderNo = urlQuery('orderNo') || sessionStorage.get(`orderNo-${urlQuery('cuid')}`)
    //
    //   let verified = 'NO'
    //   let holder = null
    //   // let pageKeys = []
    //   let hasSameAddress = ''
    //   let passportHasExpiry = false
    //   let goodsInfo
    //   // 已登陆用户，请求 detail 接口获取投保人信息
    //   if (userInfo.isLogin) {
    //     let res = await ajax({
    //       url: '/user/customer/detail',
    //       notip: true,
    //       loading: true
    //     })
    //     if (res.success) {
    //       let userData = res.value || {}
    //       userData.nationality = userData.nationality && userData.nationality.enumName
    //       actions.onlineApplicationModel.setdmMark(userData.dmMark)
    //       userData = resetInitData(userData)
    //       if (userData.passportExpiryDate) { // 护照失效日期比当前系统时间大于等于15天以上才可投保
    //         passportHasExpiry = moment(userData.passportExpiryDate).subtract(15, 'days').isBefore(moment(), 'day')
    //       }
    //
    //       // 存储zafam的信息，在联系人页面会用到
    //       const { zaFamUserInfo } = userData
    //       if (zaFamUserInfo) {
    //         actions.onlineApplicationModel.setUserData({
    //           zafamEmail: zaFamUserInfo.email,
    //           zafamMobile: zaFamUserInfo.mobile
    //         })
    //       }
    //       console.log('check userData', userData)
    //       actions.onlineApplicationModel.setUserData({
    //         useLifeUserData: !!userData.email
    //       })
    //       // 下面数据结构不一样，有好的方法麻烦一起研究
    //       let {
    //         certificateType,
    //         certificateNumber,
    //         givenName,
    //         surname,
    //         name,
    //         birthday,
    //         gender,
    //         nationality,
    //         certiFaceUrl,
    //         certiVersion,
    //         selfie,
    //         passportType,
    //         passportNo,
    //         passportExpiryDate,
    //         passportPhotoUrl,
    //         // hasSameAddress, 目前没有
    //         phoneNumber,
    //         email,
    //         confirmEmail,
    //         residentialFlat,
    //         residentialBuilding,
    //         residentialDistrict,
    //         correspondenceFlat,
    //         correspondenceBuilding,
    //         correspondenceDistrict,
    //         education
    //       } = userData
    //       verified = userData.verified
    //       if (residentialFlat === correspondenceFlat && residentialBuilding === correspondenceBuilding && residentialDistrict === correspondenceDistrict) {
    //         hasSameAddress = 'SAME'
    //       } else {
    //         hasSameAddress = 'OTHER'
    //       }
    //
    //       // 目前只写了投保人信息，被保人信息待补充
    //       holder = {
    //         certificateType,
    //         certificateNumber,
    //         givenName,
    //         surname,
    //         name,
    //         birthday,
    //         gender,
    //         nationality,
    //         certiFaceUrl,
    //         certiVersion,
    //         selfie,
    //         passportPhotoUrl,
    //         passportExpiryDate,
    //         passportNo,
    //         passportOcrInfo: {
    //           givenName,
    //           surname,
    //           gender,
    //           // birthday, 目前护照的生日信息没有获取到
    //           passportType,
    //           passportNo,
    //           passportExpiryDate,
    //           nationality,
    //           passportPhotoUrl
    //         },
    //         phoneNumber,
    //         email,
    //         confirmEmail,
    //         hasSameAddress,
    //         residentialFlat,
    //         residentialBuilding,
    //         residentialDistrict,
    //         correspondenceFlat,
    //         correspondenceBuilding,
    //         correspondenceDistrict,
    //         education
    //       }
    //     }
    //   }
    //   // URL 中存在 orderNo，请求 /order/detail 接口获取
    //   if (sessionOrderNo) {
    //     // 未登录获取订单详情里面的 holder
    //     let res = await ajax({
    //       url: '/order/detail/' + sessionOrderNo,
    //       loading: true,
    //       method: 'GET'
    //     })
    //     if (res.success) {
    //       const { orderBriefInfo = {}, products } = res.value
    //       let {
    //         goodsId,
    //         goodsPlanId,
    //         packageId,
    //         insureCusts,
    //         holderCusts = {},
    //         promoInfo = null
    //       } = orderBriefInfo
    //       let insuredInfo = insureCusts[0]
    //       console.log(insuredInfo, '-------insuredInfo')
    //       let codeObj = {}
    //       if (promoInfo && promoInfo.promoCode) {
    //         let data = {
    //           goodsId: +goodsId,
    //           payFrequencyType: insuredInfo.factors.payFrequency || '',
    //           codeValue: promoInfo.promoCode
    //         }
    //         ajax({
    //           url: '/campaign/code/detail',
    //           data
    //         }).then(res => {
    //           if (res.success) {
    //             codeObj = res.value || {}
    //             codeObj.codeValue = promoInfo.promoCode
    //             // promoInfo = codeObj
    //             actions.onlineApplicationModel.setSubmitOrderData({ promoInfo: codeObj, defaultPromoInfo: promoInfo })
    //           }
    //         })
    //       }
    //       const { residentialFlat, residentialBuilding, residentialDistrict, correspondenceFlat, correspondenceBuilding, correspondenceDistrict } = orderBriefInfo.holderCusts
    //       if (residentialFlat === correspondenceFlat && residentialBuilding === correspondenceBuilding && residentialDistrict === correspondenceDistrict) {
    //         hasSameAddress = 'SAME'
    //       } else {
    //         hasSameAddress = 'OTHER'
    //       }
    //       let factors = {
    //         'birthday': insuredInfo.birthday,
    //         'currentInsurantId': insuredInfo.customerId,
    //         'gender': insuredInfo.gender,
    //         'payFrequencyType': insuredInfo.factors.payFrequency,
    //         'paymentPeriod': insuredInfo.factors.paymentPeriod,
    //         'smoking': insuredInfo.smoking,
    //         'SA': insuredInfo.factors.SA
    //       }
    //       let promotionId = promoInfo && (promoInfo.campaignId || promoInfo.promotionId)
    //       if (promotionId) {
    //         factors.promotionId = promotionId
    //       }
    //       sessionStorage.set('calculateVals', factors)
    //       sessionStorage.set(`productListParams-${goodsPlanId}`, JSON.stringify(products))
    //       let confirmEmail = orderBriefInfo.holderCusts.email
    //       let passportOcrInfo = {
    //         givenName: holderCusts.givenName,
    //         surname: holderCusts.surname,
    //         gender: holderCusts.gender,
    //         passportType: holderCusts.passportType || 'O',
    //         passportNo: holderCusts.passportNo,
    //         passportExpiryDate: holderCusts.passportExpiryDate,
    //         nationality: holderCusts.nationality,
    //         passportPhotoUrl: holderCusts.passportPhotoUrl
    //       }
    //
    //       holder = { ...orderBriefInfo.holderCusts, hasSameAddress, confirmEmail, passportOcrInfo }
    //       holder = { ...holder, orderPhoneNumber: holder.phoneNumber, orderEmail: holder.email }
    //       let insurants = orderBriefInfo.insureCusts
    //       // if (promoInfo && promoInfo.promoCode) {
    //       //   promoInfo.codeValue = promoInfo.promoCode
    //       // }
    //       actions.onlineApplicationModel.setSubmitOrderData({ insurants })
    //       actions.onlineApplicationModel.setIdObjData({ goodsId, goodsPlanId, packageId })
    //
    //       // OCR 修改
    //       let oldOcr = {
    //         certificateType: holderCusts.certificateType,
    //         certificateNumber: holderCusts.certificateNumber,
    //         givenName: holderCusts.givenName,
    //         surname: holderCusts.surname,
    //         name: holderCusts.name,
    //         birthday: holderCusts.birthday,
    //         gender: holderCusts.gender,
    //         nationality: holderCusts.nationality,
    //         passportNo: holderCusts.passportNo
    //       }
    //       let cuid = urlQuery('cuid')
    //       let oldDataObj = JSON.parse(sessionStorage.get('oldOcrData-' + cuid))
    //       oldDataObj = { ...oldDataObj, ...oldOcr }
    //       sessionStorage.set('oldOcrData-' + cuid, oldDataObj)
    //       // 提前进行一次价格试算
    //       goodsInfo = { goodsId, goodsPlanId }
    //       actions.onlineApplicationModel.trialPrice({ holder, goodsInfo, promotionId: promoInfo && (promoInfo.campaignId || promoInfo.promotionId) })
    //       actions.onlineApplicationModel.setUserData({
    //         useLifeOrderData: true
    //       })
    //     }
    //   } else {
    //     goodsInfo = { goodsId: urlQuery('goodsId') || (idObj && idObj.goodsId), goodsPlanId: urlQuery('goodsPlanId') || (idObj && idObj.goodsPlanId) }
    //     actions.onlineApplicationModel.trialPrice({ holder, goodsInfo })
    //   }
    //   // 未实名用户，链接上不存在 sessionOrderNo 并且存在 sessionHolder 的用户，合并 holder 和当前的 sessionHolder
    //   if (userInfo.isLogin && verified === 'NO' && !sessionOrderNo) {
    //     holder = {
    //       ...holder
    //       // ...sessionHolder
    //     }
    //   } else {
    //     holder = holder || {}
    //   }
    //
    //   actions.onlineApplicationModel.setUserData({
    //     idCardUpload: holder && !!holder.certiFaceUrl,
    //     passportUpload: holder && !!holder.passportPhotoUrl,
    //     selfUpload: holder && !!holder.selfie,
    //     verified,
    //     passportHasExpiry,
    //     phoneNumber: holder.phoneNumber || '',
    //     email: holder.email || ''
    //   })
    //   // 初始化投保人信息
    //   actions.onlineApplicationModel.setSubmitOrderData({ holder })
    //
    //   if (holder.certificateNumber && holder.selfie) {
    //     actions.onlineApplicationModel.setNextDisableMap({ 'hkid': false, 'selfie': false })
    //   }
    //   if (holder.passportNo) {
    //     actions.onlineApplicationModel.setUserData({ passportUpload: true })
    //   }
    //
    //   // actions.onlineApplicationModel.setTempHolderInfo({ h5: holder, local: holder })
    //
    //   if (verified === 'YES') { // 已实名用户，显示投保人信息预览页面
    //     // if (location.search.indexOf('noDeclaration') === -1 && !sessionOrderNo) {
    //     //   pageKeys.push(PAGEKEYS[0])
    //     // } else {
    //     //   pageKeys = [PAGEKEYS[0], 'APPLICANTINFORMATION']
    //     // }
    //
    //     actions.onlineApplicationModel.setInfoFromDetail(true)
    //   } else {
    //     // if (location.search.indexOf('noDeclaration') === -1 && !sessionOrderNo) {
    //     //   pageKeys.push(PAGEKEYS[0]) // 否则，只显示第一页
    //     // } else {
    //     //   let { isPc } = getState().mainModel
    //     //   if (isPc) { // pc显示hkid 护照 自拍在一个模块
    //     //     if (holder && holder.certificateType && holder.certificateType === 'NONPERMHKID') { // 非永久要显示护照
    //     //       pageKeys = [PAGEKEYS[0], PAGEKEYS[1], PAGEKEYS[2], PAGEKEYS[3]]
    //     //     } else {
    //     //       pageKeys = [PAGEKEYS[0], PAGEKEYS[1], PAGEKEYS[3]]
    //     //     }
    //     //   } else { // 手机端只需要一步一步显示
    //     //     pageKeys = [PAGEKEYS[0], PAGEKEYS[1]]
    //     //   }
    //     // }
    //   }
    //   // actions.onlineApplicationModel.setPageKeys(pageKeys)
    // },
    // // 投保人/被保人上传id信息, userType : 1 表示投保人，2表示被保人
    // // abctodo
    // async uploadIdCard ({ file, cuid = urlQuery('cuid'), userType = 1, callback, goodsInfo, uploadChannel = 1, hkidVersion = '2003', showIndex }, getState) {
    //   let formData = new FormData()
    //   formData.append('customerMedia', MediaMap[1])
    //   formData.append('file', file)
    //   formData.append('key', cuid)
    //   formData.append('hkidVersion', hkidVersion)
    //   formData.append('type', userType === 1 ? 'HOLDER' : 'INSURANT')
    //   formData.append('uploadChannel', uploadChannel) // 1代表同步， 2代表暂不同步
    //   let res = await ajax({
    //     url: '/proxy/file/uploadCache',
    //     needToken: true,
    //     data: formData
    //     // loading: true
    //   })
    //   if (res.success) {
    //     let ocrInfo = res.value && res.value.respDTO
    //     if (userType === 1) {
    //       // 投保人逻辑
    //
    //       // 无法识别提示
    //       if (!ocrInfo.valid) {
    //         actions.onlineApplicationModel.setUserData({ idCardUpload: false, idCardUploadErrTxt: t('anan_resp_insure_sorry_msg') || 'Sorry that the picture is not clear enough, would you please upload another one?' })
    //         actions.onlineApplicationModel.setOcrUploadStatus({ ocrIdCardUpload: false })
    //         actions.onlineApplicationModel.setNextDisableMap({ 'hkid': true })
    //         return res
    //       }
    //       if (uploadChannel === 2) {
    //         // h5端不做其他校验
    //         actions.onlineApplicationModel.dealHkidOcrInfo({ ocrInfo, goodsInfo, uploadChannel })
    //         return res
    //       }
    //       actions.onlineApplicationModel.checkHolderOcrInfo({ ocrInfo, goodsInfo })
    //     } else {
    //       // 被保人逻辑
    //       // 被保人证件无法识别
    //       if (!ocrInfo.valid) {
    //         actions.onlineApplicationModel.setUserData({ insureIdCardUploadErrTxt: t('anan_resp_insure_sorry_msg') || 'Sorry that the picture is not clear enough, would you please upload another one?' })
    //         return res
    //       }
    //       actions.onlineApplicationModel.dealInsureHkIDinfo({ ocrInfo, showIndex, callback })
    //     }
    //   } else {
    //     // 这里直接用后台的提示语，因为这里会有扫码二维码链接过期、或者网络异常等不同失败场景，后台去区分
    //     // showError(Lang[res.code] || res.msg)
    //     // showError(t('anan_resp_insure_upload_failed || 'Upload failed')
    //     if (userType === 1) {
    //       actions.onlineApplicationModel.setNextDisableMap({ 'hkid': true })
    //     }
    //   }
    //   return res
    // },
    // checkHolderBirthDay (info, getState) {
    //   let { blocksMap } = getState().onlineApplicationModel
    //   let age = info.birthday && new Date(info.birthday).getTime()
    //   let [minAge, maxAge] = getAgeRange(blocksMap, urlQuery('goodsId'))
    //   let disable = false
    //   console.log('投保人年龄:', minAge, maxAge, age)
    //   if (age && (age < minAge || age > maxAge)) {
    //     console.log('上传投保人年龄 不符合范围')
    //     disable = true
    //     const tagContent = t('anan_resp_insure_social_media') || 'social media/newsfeed links'
    //     let errorMsg = template(t('anan_resp_insure_passport_ocr_tips4') || 'Based on the information you have provided, we are currently unable to offer cover for this plan. We are continually improving our products and expanding our ability to accept more risk. Please follow us on ({tag}) to hear the latest on what we can offer.', {
    //       tag: `<a href='' className=''>${tagContent}</a>`
    //     })
    //     actions.onlineApplicationModel.setUserData({ idCardUpload: true, idCardUploadErrTxt: errorMsg, ageMatch: false })
    //   }
    //   return disable
    // },
    //
    // // 对识别出的投保人ocr信息校验
    // async checkHolderOcrInfo ({ ocrInfo, setPassport, setSelfie, goodsInfo }, getState) {
    //   let { holder = {} } = getState().onlineApplicationModel.submitOrderData
    //   let info = ocrInfo.userCertificate
    //   holder.certiVersion = ocrInfo.hkidVersion
    //   let pass = true
    //   let errObj = {}
    //   actions.onlineApplicationModel.setHolderHkidVersion(ocrInfo.hkidVersion)
    //   info.name = info.name || ' '
    //   if (info.certiType === 'PERMHKID') {
    //     info.nationality = 'HONG_KONG'
    //   }
    //   info.certificateType = info.certiType
    //   info.certificateNumber = info.certiNo
    //   info.certiFaceUrl = ocrInfo.pictureCode
    //   let cuid = urlQuery('cuid')
    //   let oldDataObj = JSON.parse(sessionStorage.get('oldOcrData-' + cuid))
    //   let newDataObj = JSON.parse(sessionStorage.get('newOcrData-' + cuid))
    //   let cleanObj = setPassport ? {} : { passportNo: '', passportExpiryDate: '', passportPhotoUrl: '', passportOcrInfo: {} }
    //
    //   if (!setSelfie && holder.selfie) {
    //     actions.onlineApplicationModel.setOldSelfie(holder.selfie)
    //   }
    //   let selfie = setSelfie ? holder.selfie : ''
    //   oldDataObj = { ...oldDataObj, ...info, ...cleanObj }
    //   newDataObj = { ...newDataObj, ...info, ...cleanObj }
    //   sessionStorage.set('oldOcrData-' + cuid, oldDataObj)
    //   sessionStorage.set('newOcrData-' + cuid, newDataObj)
    //   let isVerifyCerti = await actions.onlineApplicationModel.verifyCerti(info)
    //   if (actions.onlineApplicationModel.checkHolderBirthDay(info)) {
    //     pass = false
    //   } else if (isVerifyCerti) {
    //     pass = false
    //     errObj = { idCardUpload: true, idCardUploadErrTxt: '', isVerifyCerti: true }
    //   } else {
    //     actions.onlineApplicationModel.setUserData({ ageMatch: true, isVerifyCerti: false })
    //     actions.onlineApplicationModel.dealHkidOcrInfo({ ocrInfo, setPassport, setSelfie, goodsInfo })
    //   }
    //   if (!pass) {
    //     let holderData = { ...holder, ...info, ...cleanObj, ...{ selfie: selfie } }
    //     actions.onlineApplicationModel.setUserData(errObj)
    //     actions.onlineApplicationModel.setNextDisableMap({ 'hkid': true, selfie: true })
    //     actions.onlineApplicationModel.setOcrUploadStatus({ ocrIdCardUpload: true })
    //     actions.onlineApplicationModel.setSubmitOrderData({ holder: holderData }) // 设置所有数据
    //   }
    //   setTimeout(() => {
    //     if (setPassport && holder && holder.passportOcrInfo) {
    //       actions.onlineApplicationModel.dealPassportOcrInfo({ passportInfo: holder.passportOcrInfo })
    //     }
    //   }, 0)
    // },
    //
    // // 轮询ocr信息
    // async requestFileQuery ({ callback, goodsInfo, cuid, type, showIndex }, getState) {
    //   if (!cuid) {
    //     return
    //   }
    //
    //   let res = await ajax({
    //     url: '/file/query?key=' + cuid,
    //     method: 'get',
    //     loading: false
    //   })
    //   // actions.mainModel.resetTime()
    //
    //   timer = setTimeout(() => { actions.onlineApplicationModel.requestFileQuery({ callback, goodsInfo, cuid, type, showIndex }) }, 2000)
    //   if (res.success) {
    //     let data = res.value
    //     let { insureOcrInfo = {}, submitOrderData, birthCertiImg, currentKey, oldSelfie } = getState().onlineApplicationModel
    //     let { holder = {} } = submitOrderData
    //     let holdersData = (data && data.holder) || []
    //     let insurantsData = (data && data.insurant) || []
    //     let holderId = getAttrObject(holdersData, 'customerMedia', 'ID_FRONT_IMAGE')[0]// 投保人身份证
    //     let holderPassport = getAttrObject(holdersData, 'customerMedia', 'PASSPORT_IMAGE')[0] // 投保人护照
    //     let holderSelfie = getAttrObject(holdersData, 'customerMedia', 'SELFIE_IMAGE')[0] // 投保人自拍
    //     let insureId = getAttrObject(insurantsData, 'customerMedia', 'ID_FRONT_IMAGE')[0] // 被保人身份证
    //     let insureBirthCerti = getAttrObject(insurantsData, 'customerMedia', 'SELFIE_IMAGE')[0] // 被保人出生证明
    //     // if (!holderId && !holderPassport && !holderSelfie && !insureId) {
    //     //   return
    //     // }
    //
    //     let hasInfo = {
    //       1: false, 2: false, 3: false
    //     }
    //     console.log('fileversion:', res && res.value && res.value.version)
    //
    //     // if (!this.version || this.version === 0) {
    //     //   if (this.version !== (res.value && res.value.version)) {
    //     //     this.version = res.value && res.value.version
    //
    //     // 护照
    //     if (holderPassport && (holderPassport.fileUniqueCode !== holder.passportPhotoUrl || !holder.passportPhotoUrl)) {
    //       console.log('holderPassport', holderPassport)
    //       if (holder && (holder.certificateType === 'NONPERMHKID' || !holder.certificateType)) {
    //         let passportInfo = holderPassport && holderPassport.passportInfo
    //         hasInfo[2] = true
    //         actions.onlineApplicationModel.dealPassportOcrInfo({ passportInfo })
    //       }
    //     }
    //     if (holder && holder.certificateType === 'PERMHKID') {
    //       hasInfo[2] = true
    //     }
    //     // 自拍
    //     if (holderSelfie && (holderSelfie.fileUniqueCode !== holder.selfie || !holder.selfie) && holderSelfie.fileUniqueCode !== oldSelfie) {
    //       console.log('holderSelfie', holderSelfie)
    //       hasInfo[3] = true
    //       let obj = holderSelfie
    //       if (holderId && holderId.fileUniqueCode) {
    //         obj = { ...holderSelfie, ...{ holderFront: holderId.fileUniqueCode } }
    //       }
    //       // actions.onlineApplicationModel.setSubmitOrderData({ holder: { ...holder, ...{ selfie: holderSelfie.fileUniqueCode } } })
    //       actions.onlineApplicationModel.checkIdCardAndSelfie(obj)
    //     }
    //     // 投保人hkid
    //     let ocrInfo = holderId && holderId.respDTO
    //     if (holderId && (holderId.fileUniqueCode !== holder.certiFaceUrl || !holder.certiFaceUrl)) {
    //       hasInfo[1] = true
    //       console.log('holderIdxxx:', holderId, holderId.respDTO)
    //       // let selfie = holderSelfie && holderSelfie.fileUniqueCode
    //       actions.onlineApplicationModel.checkHolderOcrInfo({ ocrInfo, setPassport: hasInfo[2], setSelfie: hasInfo[3], passportInfo: holderPassport && holderPassport.passportInfo, goodsInfo })
    //     }
    //     if (type.indexOf('holder') > -1 && ((hasInfo[2] && hasInfo[1] && hasInfo[3]) || currentKey !== 'HOLDER')) {
    //       clearTimeout(timer)
    //       timer = null
    //     }
    //     //   }
    //     // } else {
    //     //   this.version = res.value && res.value.version
    //     // }
    //
    //     // 被保人hkid
    //     if (type === 'insureId' && insureId && insureId.fileUniqueCode && insureId.fileUniqueCode !== insureOcrInfo.certiFaceUrl) {
    //       clearTimeout(timer)
    //       timer = null
    //       let ocrInfo1 = insureId.respDTO
    //       actions.onlineApplicationModel.dealInsureHkIDinfo({ ocrInfo: ocrInfo1, showIndex, callback })
    //     }
    //     // 被保人出生证明
    //     if (type === 'insureBirthcerti' && insureBirthCerti && insureBirthCerti.fileUniqueCode && insureBirthCerti.fileUniqueCode !== birthCertiImg) {
    //       clearTimeout(timer)
    //       timer = null
    //       actions.onlineApplicationModel.setBirthCertiImg(insureBirthCerti.fileUniqueCode)
    //       callback && callback(insureBirthCerti.fileUniqueCode)
    //     }
    //   }
    //   // return res
    // },
    // // 检查证件是否绑定了某个账号
    // async verifyCerti ({ certiType, certiNo }) {
    //   let res = await ajax({
    //     url: '/user/isCertiBinded',
    //     loading: true,
    //     needToken: true,
    //     data: {
    //       'certiType': certiType,
    //       'certiNo': certiNo
    //     }
    //   })
    //   if (res.success) {
    //     let verifyData = res.value || {}
    //     return verifyData.success && verifyData.verified
    //   } else {
    //     return false
    //   }
    // },
    // // 处理被保人ocr信息
    // dealInsureHkIDinfo ({ ocrInfo, showIndex, callback }, getState) {
    //   let info = ocrInfo.userCertificate
    //   info.certiVersion = ocrInfo.hkidVersion
    //   let { insureHkidVersionMap } = getState().onlineApplicationModel
    //   let map = Object.assign(insureHkidVersionMap, { [showIndex]: ocrInfo.hkidVersion })
    //   actions.onlineApplicationModel.setInsureHkidVersionMap(map)
    //   console.log('xxxshowIndex33:', showIndex)
    //   info.name = info.name || ' '
    //   info.certificateType = info.certiType
    //   info.certificateNumber = info.certiNo
    //   info.certiFaceUrl = ocrInfo.pictureCode
    //   info.upload = true
    //   callback && callback(info)
    //   actions.onlineApplicationModel.setUserData({ insureIdCardUploadErrTxt: '' })
    //   actions.onlineApplicationModel.setInsureOcrInfo(info)
    //   actions.onlineApplicationModel.setInsureObjData({ oldData: info })
    // },
    // // 处理上传完 id card 逻辑
    // dealHkidOcrInfo ({ ocrInfo, goodsInfo, setPassport, setSelfie, uploadChannel = 1 }, getState) {
    //   let { pageKeys, submitOrderData } = getState().onlineApplicationModel
    //   let { holder = {} } = submitOrderData
    //   let info = ocrInfo.userCertificate
    //   holder.certiVersion = ocrInfo.hkidVersion
    //   info.name = info.name || ' '
    //   // 国籍的处理
    //   let nationality = ''
    //   if (setPassport) {
    //     nationality = holder.nationality
    //   }
    //   if (info.certiType === 'PERMHKID') { // 通过 id 卡并且是永久身份证的 国籍设置为 hk
    //     nationality = 'HONG_KONG'
    //   }
    //   info.nationality = nationality
    //   info.certificateType = info.certiType
    //   info.certificateNumber = info.certiNo
    //   info.certiFaceUrl = ocrInfo.pictureCode
    //   holder = { ...holder, ...info }
    //
    //   // OCR 修改
    //   let cuid = urlQuery('cuid')
    //   let oldDataObj = JSON.parse(sessionStorage.get('oldOcrData-' + cuid))
    //   let newDataObj = JSON.parse(sessionStorage.get('newOcrData-' + cuid))
    //   oldDataObj = { ...oldDataObj, ...info }
    //
    //   newDataObj = { ...newDataObj, ...info }
    //   let obj = { 'hkid': false }
    //   // 错误信息的处理
    //   let errObj = { idCardUpload: true, idCardUploadErrTxt: '' }
    //   if (!setPassport) {
    //     errObj = { ...errObj, ...{ passportUpload: false, passportUploadErrTxt: '' } }
    //   }
    //   if (!setSelfie) {
    //     errObj = { ...errObj, ...{ selfUpload: false } }
    //   }
    //   let cleanObj = setPassport ? {} : { passportNo: '', passportExpiryDate: '', passportPhotoUrl: '', passportOcrInfo: {} }
    //   if (!setSelfie && holder.selfie) {
    //     actions.onlineApplicationModel.setOldSelfie(holder.selfie)
    //   }
    //   let selfie = setSelfie ? holder.selfie : ''
    //   oldDataObj = { ...oldDataObj, ...cleanObj }
    //   newDataObj = { ...newDataObj, ...cleanObj }
    //   if (holder.passportNo && !setPassport) {
    //     obj.passport = true
    //   }
    //   if (holder.selfie && !setSelfie) {
    //     obj.selfie = true
    //   }
    //   if (info.certiType === 'PERMHKID') { // 如果是永久证件照 则设置护照的disable为false
    //     obj.passport = false
    //   }
    //
    //   holder = { ...holder, ...cleanObj, ...{ selfie: selfie } }
    //   sessionStorage.set('oldOcrData-' + cuid, oldDataObj)
    //   sessionStorage.set('newOcrData-' + cuid, newDataObj)
    //
    //   // 设置上传 ocr 信息
    //   actions.onlineApplicationModel.setUserData(errObj)
    //   actions.onlineApplicationModel.setOcrUploadStatus({ ocrIdCardUpload: true, ocrPassportUpload: false })
    //   actions.onlineApplicationModel.setSubmitOrderData({ holder })
    //   if (uploadChannel === 2) {
    //     return
    //   }
    //   actions.onlineApplicationModel.setNextDisableMap(obj)
    //
    //   // 如果存在护照则需要判断护照和 id card 是否一致
    //   // if (info.certiType !== 'PERMHKID' && holder.passportOcrInfo && Object.values(holder.passportOcrInfo).filter((value) => { return !!value }).length > 0) {
    //   //   if (!judgeOcrInfo(holder, holder.passportOcrInfo)) {
    //   //     console.log('护照信息与当前id card 不一致')
    //   //     let passportUploadErrTxt = t('anan_resp_insure_passport_ocr_tips || 'Sorry that the passport does not match with the HKID , would you please upload the correct HKID and/or the passort?'
    //   //     actions.onlineApplicationModel.setUserData({ passportUpload: false, passportUploadErrTxt })
    //   //     actions.onlineApplicationModel.setOcrUploadStatus({ ocrPassportUpload: false })
    //   //     actions.onlineApplicationModel.setInsureNextDisable(true)
    //   //     actions.onlineApplicationModel.setSubmitOrderData({ certiFaceUrl: ocrInfo.pictureCode }) // 仅设置url
    //   //     actions.onlineApplicationModel.setNextDisableMap({ 'passport': true })
    //   //   } else {
    //   //     actions.onlineApplicationModel.setNextDisableMap({ 'hkid': false, passport: false })
    //   //     actions.onlineApplicationModel.setUserData({ passportUploadErrTxt: '', passportUpload: true })
    //   //     actions.onlineApplicationModel.setOcrUploadStatus({ ocrPassportUpload: true })
    //   //   }
    //   // }
    //   // 非永久-》=》过期护照=》永久-》非永久 要再次校验下已经上传过的护照是否有错误 是否为空
    //   // if (info.certiType !== 'PERMHKID' && !holder.passportNo) {
    //   //   actions.onlineApplicationModel.setNextDisableMap({ 'passport': true })
    //   // }
    //
    //   // 如果存在大头照
    //   // if (holder.selfie) {
    //   //   actions.onlineApplicationModel.checkIdCardAndSelfie({ fileUniqueCode: holder.selfie })
    //   // }
    //
    //   // 当前页面不存在选择被保人页面时,此处会根据新上传的投保人信息进行一次试算
    //   pageKeys.indexOf('INSURECHOOSE') === -1 && actions.onlineApplicationModel.trialPrice({ holder, goodsInfo })
    //
    //   // 判断用户当前步骤是不是上传 id card
    //   // 不是上传 id card 的话操作上传护照的上传与关闭
    //   // if (pageKeys.length !== 1) {
    //   //   actions.onlineApplicationModel.nextPage({ ...goodsInfo, callPosition: 'dealHkidOcrInfo' })
    //   // }
    // },
    // // 上传护照
    // async uploadPassport ({ cuid = urlQuery('cuid'), file, uploadChannel = 1 }) {
    //   let formData = new FormData()
    //   formData.append('customerMedia', MediaMap[2])
    //   formData.append('file', file)
    //   formData.append('key', cuid)
    //   formData.append('type', 'HOLDER')
    //   formData.append('uploadChannel', uploadChannel) // 1代表PC， 2代表h5
    //   let res = await ajax({
    //     url: '/proxy/file/uploadCache',
    //     needToken: true,
    //     data: formData
    //     // loading: true
    //   })
    //   // 判断接口是否返回正确，返回错误给予提示
    //   if (res.success) {
    //     actions.onlineApplicationModel.dealPassportOcrInfo({ passportInfo: res.value && res.value.passportInfo, uploadChannel })
    //   } else {
    //     // 上传报错
    //     showError(t(res.code) || res.msg)
    //     actions.onlineApplicationModel.setNextDisableMap({ 'passport': true })
    //   }
    //   return res
    // },
    // // 处理上传完护照的逻辑
    // dealPassportOcrInfo ({ passportInfo = {}, uploadChannel = 1 }, getState) {
    //   const { passportNo, passportExpiryDate, nationality, pictureCode } = passportInfo
    //   let { submitOrderData, blocksMap } = getState().onlineApplicationModel
    //   let { holder } = submitOrderData
    //   let passportUploadErrTxt = ''
    //   const blockData = blocksMap[1] || []
    //   const nationalityList = getAttrObject(blockData, 'customizeCode', 'nationality')[0] || {}
    //   // 校验失效日期是否大于等于15天，错误需给出提示
    //   // 校验英文姓氏，英文姓名，性别，出生日期等是否与HKID的信息一致，不一致给出提示
    //   // 渲染护照失效日期和护照号码和护照的图片
    //   let valid = ''
    //   if (!passportNo) {
    //     console.log('无法识别')
    //     valid = t('anan_resp_insure_sorry_msg') || 'Sorry that the picture is not clear enough, would you please upload another one?'
    //   } else if (uploadChannel !== 2 && passportExpiryDate && moment(passportExpiryDate).isBefore(moment())) {
    //     // 护照过期提示
    //
    //     passportUploadErrTxt = t('anan_resp_insure_passport_ocr_tips1') || 'This passport is expired. Please upload a valid passport.'
    //   } else if (uploadChannel !== 2 && passportExpiryDate && moment(passportExpiryDate).subtract(14, 'days').isBefore(moment())) {
    //     // 距离护照过期只有14天提示
    //     passportUploadErrTxt = t('anan_resp_insure_passort15') || 'Please submit a new passport to us as the current one would expire very soon'
    //   } else if (uploadChannel !== 2 && !judgeOcrInfo(holder, passportInfo)) {
    //     // id card 与护照信息不匹配提示
    //
    //     passportUploadErrTxt = t('anan_resp_insure_passport_ocr_tips3') || 'Sorry that the passport does not match with the HKID , would you please upload the correct HKID and/or the passort?'
    //   } else if (uploadChannel !== 2 && nationality && !checkNationality(nationality, (nationalityList && nationalityList.values) || [])) {
    //     // 护照的国籍不在当前国籍列表内提示
    //     actions.onlineApplicationModel.setNationInList(false)
    //     passportUploadErrTxt = t('anan_resp_insure_IAdemo_passport_ocr_tips2') || 'Sorry, we cannot accept the application based on your nationality.'
    //   }
    //   if (uploadChannel !== 2 && nationality && checkNationality(nationality, (nationalityList && nationalityList.values) || [])) {
    //     actions.onlineApplicationModel.setNationInList(true)
    //   }
    //   // 如果护照无法识别
    //   if (valid) {
    //     actions.onlineApplicationModel.setUserData({ passportUpload: false, passportUploadErrTxt: valid })
    //     actions.onlineApplicationModel.setOcrUploadStatus({ ocrPassportUpload: false })
    //     actions.onlineApplicationModel.setNextDisableMap({ 'passport': true })
    //     actions.onlineApplicationModel.setSubmitOrderData({ holder: { ...holder, passportPhotoUrl: pictureCode } })// 此处仅展示护照图片
    //     return
    //   } else if (passportUploadErrTxt) { // 护照有其他报错
    //     actions.onlineApplicationModel.setUserData({ passportUpload: true, passportUploadErrTxt })
    //     // actions.onlineApplicationModel.setOcrUploadStatus({ ocrPassportUpload: true })
    //     actions.onlineApplicationModel.setNextDisableMap({ 'passport': true })
    //   } else {
    //     actions.onlineApplicationModel.setNextDisableMap({ 'passport': false })
    //     // holder = { ...holder, ...{ passportNo, passportExpiryDate, nationality, passportPhotoUrl: pictureCode, passportOcrInfo: passportInfo } }
    //     actions.onlineApplicationModel.setUserData({ passportUpload: true, passportUploadErrTxt: '' })
    //     // actions.onlineApplicationModel.setOcrUploadStatus({ ocrPassportUpload: true })
    //     // actions.onlineApplicationModel.setSubmitOrderData({ holder })
    //   }
    //   // else if (pageKeys.slice(-1)[0] === 'APPLICANTINFORMATION') {
    //   //   actions.onlineApplicationModel.setNextDisableMap({ 'passport': false })
    //   // }
    //   // if (pageKeys.slice(-1)[0] === 'UPLOADPASSPORT') {
    //   //   // actions.onlineApplicationModel.setInsureNextDisable(false)
    //
    //   // }
    //   // actions.onlineApplicationModel.setNextDisableMap({ 'passport': false })
    //   holder = { ...holder, ...{ passportNo, passportExpiryDate, nationality, passportPhotoUrl: pictureCode, passportOcrInfo: passportInfo } }
    //   console.log('护照holder:', holder)
    //   // actions.onlineApplicationModel.setUserData({ passportUpload: true, passportUploadErrTxt: '' })
    //   actions.onlineApplicationModel.setOcrUploadStatus({ ocrPassportUpload: true })
    //   actions.onlineApplicationModel.setSubmitOrderData({ holder })
    //   // OCR 修改
    //   let infoOcr = { passportNo, passportExpiryDate, nationality, passportPhotoUrl: pictureCode, passportOcrInfo: passportInfo }
    //
    //   let cuid = urlQuery('cuid')
    //   let oldDataObj = JSON.parse(sessionStorage.get('oldOcrData-' + cuid))
    //   let newDataObj = JSON.parse(sessionStorage.get('newOcrData-' + cuid))
    //   oldDataObj = { ...oldDataObj, ...infoOcr }
    //   newDataObj = { ...newDataObj, ...infoOcr }
    //   sessionStorage.set('oldOcrData-' + cuid, oldDataObj)
    //   sessionStorage.set('newOcrData-' + cuid, newDataObj)
    // },
    // // 上传出生证明
    // async uploadBirthCerti ({ file, uploadChannel = 1, callback }) {
    //   let formData = new FormData()
    //   formData.append('customerMedia', 'SELFIE_IMAGE')
    //   formData.append('file', file)
    //   formData.append('key', urlQuery('cuid'))
    //   formData.append('type', 'INSURANT')
    //   formData.append('uploadChannel', uploadChannel) // 1代表实时同步， 2代表不同步
    //   let res = await ajax({
    //     url: '/proxy/file/uploadCache',
    //     needToken: true,
    //     data: formData
    //   })
    //   if (res.success) {
    //     let birthCertiImg = res.value.fileUniqueCode || ''
    //     callback && callback(birthCertiImg)
    //   } else {
    //     showError(t(res.code) || res.msg)
    //   }
    //   return res
    // },
    // // 上传大头照
    // async uploadAvatar ({ cuid = urlQuery('cuid'), file, uploadChannel = 1 }, getState) {
    //   let { holder = {} } = getState().onlineApplicationModel.submitOrderData
    //   let formData = new FormData()
    //   formData.append('customerMedia', MediaMap[3])
    //   formData.append('file', file)
    //   formData.append('key', cuid)
    //   formData.append('type', 'HOLDER')
    //   formData.append('uploadChannel', uploadChannel) // 1代表实时同步， 2代表不同步
    //   let res = await ajax({
    //     url: '/proxy/file/uploadCache',
    //     needToken: true,
    //     data: formData
    //     //  loading: true
    //   })
    //   if (res.success) {
    //     if (uploadChannel === 2) {
    //       // 扫描二维码出来的h5端不做校验
    //       holder = { ...holder, ...{ selfie: res.value.fileUniqueCode } }
    //       actions.onlineApplicationModel.setUserData({ selfUpload: true, selfUploadErrTxt: '' })
    //       actions.onlineApplicationModel.setSubmitOrderData({ holder })
    //       return res
    //     } else {
    //       // 验证当前上传的 id 卡与大头照是否一样
    //       actions.onlineApplicationModel.checkIdCardAndSelfie(res.value)
    //     }
    //   } else {
    //     showError(t(res.code) || res.msg)
    //   }
    //   return res
    // },
    // // 查询 id card 和 大头照是否匹配接口
    // async checkIdCardAndSelfie (data, getState) {
    //   let { submitOrderData } = getState().onlineApplicationModel
    //   let { holder = {} } = submitOrderData
    //   let idUniqueCode = data.holderFront || holder.certiFaceUrl // id card
    //   let selfieUniqueCode = data.fileUniqueCode // 大头照
    //   holder = { ...holder, ...{ selfie: selfieUniqueCode } }
    //   actions.onlineApplicationModel.setSubmitOrderData({ holder })
    //   console.log('checkIdCardAndSelfie', data, idUniqueCode, holder)
    //   if (!idUniqueCode || !selfieUniqueCode) {
    //     return
    //   }
    //   let res = await ajax({
    //     url: '/ocr/faceVerification',
    //     data: {
    //       idUniqueCode,
    //       selfieUniqueCode
    //     },
    //     loading: true
    //   })
    //   if (res.success) {
    //     // 验证成功后端返回 resultCode = 0
    //     if (res.value.resultCode === '0') {
    //       // 如果匹配，设置图片 url
    //       actions.onlineApplicationModel.setUserData({ selfUpload: true, selfUploadErrTxt: '' })
    //       actions.onlineApplicationModel.setNextDisableMap({ 'selfie': false })
    //       console.log('验证成功')
    //     } else {
    //       actions.onlineApplicationModel.setUserData({ selfUpload: false, selfUploadErrTxt: t('anan_resp_insure_not_match_msg') || 'Sorry, we cannot match your selfie photo with your ID card.Please upload another one.' })
    //       actions.onlineApplicationModel.setNextDisableMap({ 'selfie': true })
    //       console.log('验证失败')
    //     }
    //   } else {
    //     showError(t('anan_resp_insure_check_failed') || 'Check failed')
    //     actions.onlineApplicationModel.setNextDisableMap({ 'selfie': true })
    //   }
    // },
    // // 获取在同行展示时的OCR信息块
    // getPernamentDom ({ type, RENDERKEYS, data = {} }, getState) {
    //   let { blocksMap } = getState().onlineApplicationModel
    //   const blockData = blocksMap[type] || []
    //   const result = sortAndGetValue({ data: blockData, valueObj: data, sortArray: RENDERKEYS })
    //   return result
    // },
    // // 上一页
    // prePage (data, getState) {
    //   let goodsId = urlQuery('goodsId') || data.goodsId
    //   let temp = [...PAGEKEYS]
    //   if (+goodsId !== 253005) {
    //     temp.splice(temp.indexOf('INSURECHOOSE'), 1)
    //   } else {
    //     temp.splice(temp.indexOf('BENEFICIARY'), 1)
    //   }
    //   let { currentKey = temp[0] } = getState().onlineApplicationModel
    //   let preIndex = temp.indexOf(currentKey) - 1
    //   if (preIndex >= 0) { // 不是第一步
    //     currentKey = temp[preIndex]
    //     actions.onlineApplicationModel.setCurrentKey(currentKey)
    //   } else {
    //     let { search } = window.location
    //     if (search.indexOf('view') === -1) {
    //       window.location.href = `/productdetail?goodsId=${goodsId}`
    //     } else {
    //       window.location.href = `/center/policy?view=2`
    //     }
    //   }
    // },
    // // 下一页
    // nextPage (data, getState) {
    //   // let { callPosition } = data
    //   let goodsId = urlQuery('goodsId') || data.goodsId
    //   // let { pageKeys } = getState().onlineApplicationModel
    //   // let { holder = {} } = submitOrderData
    //   // let lastKey
    //   let temp = [...PAGEKEYS]
    //   if (+goodsId !== 253005) {
    //     temp.splice(temp.indexOf('INSURECHOOSE'), 1)
    //   } else {
    //     temp.splice(temp.indexOf('BENEFICIARY'), 1)
    //   }
    //   let { currentKey = temp[0] } = getState().onlineApplicationModel
    //   let nextIndex = temp.indexOf(currentKey) + 1
    //   if (nextIndex < temp.length) { // 不是最后一步
    //     currentKey = temp[nextIndex]
    //     actions.onlineApplicationModel.setCurrentKey(currentKey)
    //   }
    //   console.log('currentKey:', currentKey)
    //   actions.onlineApplicationModel.setPageKeys(temp.slice(0, temp.indexOf(currentKey) + 1))
    //   // actions.onlineApplicationModel.setPageKeys(temp)
    //   // switch (callPosition) {
    //   //   case 'dealHkidOcrInfo':
    //   //     lastKey = pageKeys[pageKeys.length - 1]
    //   //     actions.onlineApplicationModel.setPageKeys(temp.slice(0, temp.indexOf(lastKey) + 1))
    //   //     break
    //   //   default:
    //   //     actions.onlineApplicationModel.setPageKeys(temp.slice(0, pageKeys.length + 1))
    //   //     break
    //   // }
    //
    //   // 已实名用户
    //   // if (userData.verified === 'YES') {
    //   // let tempNext  已实名用户不在这里特殊处理
    //   // if (pageKeys.indexOf('APPLICANTINFORMATION') > -1) {
    //   //   tempNext = +goodsId === 253005 ? 'INSURECHOOSE' : 'BENEFICIARY'
    //   // } else {
    //   //   tempNext = 'APPLICANTINFORMATION'
    //   // }
    //
    //   // actions.onlineApplicationModel.setPageKeys([...pageKeys, tempNext])
    //   // let tempArr = [...pageKeys, tempNext]
    //   // if (Math.max(pageKeys.indexOf('INSURECHOOSE'), pageKeys.indexOf('BENEFICIARY')) > -1) {
    //   //   tempArr.push('INSUREDDECLARATION')
    //   // }
    //   // actions.onlineApplicationModel.setPageKeys(tempArr)
    //   // return
    //   //  }
    //
    //   // 未实名用户
    //   // let temp = [...PAGEKEYS]
    //   // let isPc = getState().mainModel.isPc
    //   // if (holder.certificateType && holder.certificateType !== 'NONPERMHKID') { // 当前为上传 id card 页面，并且证件类型为永久
    //   //   temp.splice(temp.indexOf('UPLOADPASSPORT'), 1)
    //   // }
    //   // if (+goodsId !== 253005) {
    //   //   temp.splice(temp.indexOf('INSURECHOOSE'), 1)
    //   // } else {
    //   //   temp.splice(temp.indexOf('BENEFICIARY'), 1)
    //   // }
    //
    //   // if (pageKeys.length === 1) {
    //   // if (!holder.certificateType || (holder.certificateType && holder.certificateType === 'PERMHKID')) {
    //   //   temp.splice(temp.indexOf('UPLOADPASSPORT'), 1)
    //   // } else if (temp.indexOf('UPLOADPASSPORT') < 0) {
    //   //   temp.splice(temp.indexOf('UPLOADIDCARD'), 0, 'UPLOADPASSPORT')
    //   // }
    //   // pageKeys = temp.slice(0, temp.indexOf('UPLOADAVATAR'))
    //   // }
    //
    //   // switch (callPosition) {
    //   //   case 'dealHkidOcrInfo':
    //   //     lastKey = pageKeys[pageKeys.length - 1]
    //   //     actions.onlineApplicationModel.setPageKeys(temp.slice(0, temp.indexOf(lastKey) + 1))
    //   //     break
    //   //   default:
    //   //     actions.onlineApplicationModel.setPageKeys(temp.slice(0, pageKeys.length + 1))
    //   //     break
    //   // }
    // },
    // // 试算，该方法目前主要用于 id card页面的调用
    // trialPrice ({ holder, goodsInfo, promotionId }, getState) {
    //   let onlineApplicationModel = getState().onlineApplicationModel
    //   let factorParams = Trial.getInitTrialFactors() || {}
    //   // 如果获取 session 的试算因子不存在，获取默认值
    //   if (!factorParams) {
    //     factorParams = {}
    //     let factorList = onlineApplicationModel.factorList
    //     factorList.map((item) => {
    //       if (!item.show.defaultValue) {
    //         factorParams[item.customizeCode] = item.values[0].customizeValue
    //       } else {
    //         factorParams[item.customizeCode] = item.show.defaultValue
    //       }
    //       if (item.customizeCode === 'birthday') {
    //         factorParams[item.customizeCode] += ' 00:00:00'
    //       }
    //     })
    //   }
    //   factorParams = {
    //     ...factorParams,
    //     birthday: holder.birthday || factorParams.birthday,
    //     gender: holder.gender || factorParams.gender,
    //     relationWithHolders: 'SELF'
    //   }
    //   if (!holder.smoking) {
    //     holder.smoking = factorParams.smoking
    //   }
    //   if (promotionId) {
    //     factorParams.promotionId = promotionId
    //   }
    //
    //   actions.onlineApplicationModel.setSubmitOrderData({ holder })
    //   const { goodsId, goodsPlanId } = goodsInfo
    //   Trial.trialPrice({ goodsPlanId, goodsId, factorParams }, (price, value) => {
    //     // if (promotionType) {
    //     //   value['promotionType'] = promotionType
    //     // }
    //     actions.onlineApplicationModel.setPremium(value)
    //     actions.onlineApplicationModel.setUserData({ payFrequencyType: factorParams.payFrequencyType })
    //     sessionStorage.set('calculateVals', factorParams)
    //   })
    // },
    // // 获取试算因子
    // async requestFactors (data) {
    //   let res = await new Promise((resolve, reject) => {
    //     Trial.requestTrialDatasource(data, (factorList) => {
    //       resolve(factorList)
    //     }, (err) => {
    //       reject(err)
    //     })
    //   })
    //   actions.onlineApplicationModel.setInit({ factorList: res })
    // },
    // // 保额范围
    // async requestSaRange (data) {
    //   let res = await ajax({
    //     url: '/market/sa/range',
    //     loading: true,
    //     data
    //   })
    //   actions.onlineApplicationModel.setInit({ saRange: res.value })
    // },
    // // 获取缴费频率 txt
    // getPayFrequency (data, getState) {
    //   let { userData = {} } = getState().onlineApplicationModel
    //   let { payFrequencyType } = userData
    //   let payFrequencyText = (payFrequencyType && paymentFrequencyMap[payFrequencyType.split('_')[0]]) || ''
    //   console.log('payFrequencyText', payFrequencyText, payFrequencyType)
    //   // for (let i = 0; i < factorList.length; i++) {
    //   //   if (factorList[i].customizeCode === 'payFrequencyType') {
    //   //     let arr
    //   //     arr = factorList[i].values.filter((item) => {
    //   //       return item.customizeValue === payFrequencyType
    //   //     })
    //   //     if (arr.length !== 0) {
    //   //       payFrequencyText = arr[0].customizeText
    //   //     }
    //   //   }
    //   // }
    //   return payFrequencyText
    // },
    // async getFileSrcNoState ({ fileSrcNo, type }, getState) {
    //   let { currentKey } = getState().onlineApplicationModel
    //   if (type === 1 && currentKey !== 'HOLDER') {
    //     return
    //   }
    //   await new Promise((resolve) => {
    //     setTimeout(() => { resolve() }, 1000)
    //   })
    //   // actions.mainModel.resetTime()
    //   let res = await ajax({
    //     url: '/file/fileSrcNo/detail',
    //     data: {
    //       fileSrcNo
    //     },
    //     loading: false
    //   })
    //   let fileSrcNoStatus = ''
    //   if (res.success) {
    //     fileSrcNoStatus = res.value.fileSrcNoStatus
    //   }
    //   return fileSrcNoStatus
    // }
  }
}
